import logo from "./logo.svg";
import Navbar from "./components/Navbar";
import React, { useState, useEffect } from "react";
import { token } from "./spotify";
import Homepage from "./pages/Homepage";

function App() {
  const [accessToken, setAccessToken] = useState("");
  useEffect(() => {
    setAccessToken(token);
  }, []);

  return (
    <div>
      <Homepage token={accessToken} />
    </div>
  );
}

export default App;
